import axios from "axios";

export const state = {
    reportsavingsbymonths: [],
};

export const getters = {
    reportsavingsbymonths: state => state.reportsavingsbymonths,
};

export const mutations = {
    setReportSavingsbyMonths(reportsavingsbymonths, newValue) { state.reportsavingsbymonths = newValue},
};

export const actions = {
    async fetchReportSavingsbyMonths({ commit }) {
        await axios.get('/reportsavingsbymonths').then(res => {
            commit('setReportSavingsbyMonths', res.data.savings)
        })
    },
    async filterReportSavingsbyMonths({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filterreportsavingsbymonths";
        await axios.post(url, formData).then((response) => {
            commit('setReportSavingsbyMonths', response.data.savings)
        })
    },
};
